import React from 'react';
import { getJournalFieldOptions } from '../utils/journalFields';

export default function ConfigurableJournalInput({
  field,
  value,
  onChange,
  className = '',
  placeholder,
  name,
  inputProps = {},
}) {
  if (!field || field.enabled === false) return null;
  const resolvedPlaceholder = field.placeholder || placeholder || 'Enter value';

  if (field.fieldType === 'dropdown') {
    return (
      <select
        name={name}
        value={value || ''}
        onChange={(event) => onChange(event.target.value, event)}
        className={className}
        {...inputProps}
      >
        <option value="">{resolvedPlaceholder}</option>
        {getJournalFieldOptions(field, value).map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    );
  }

  return (
    <input
      name={name}
      type="text"
      value={value || ''}
      onChange={(event) => onChange(event.target.value, event)}
      className={className}
      placeholder={resolvedPlaceholder}
      {...inputProps}
    />
  );
}
